import { cn } from '@/lib/utils'

interface SpinnerProps {
  tamano?: 'sm' | 'md' | 'lg'
  className?: string
}

export function Spinner({ tamano = 'md', className }: SpinnerProps) {
  const tamanos = {
    sm: 'w-3.5 h-3.5 border-[1.5px]',
    md: 'w-5 h-5 border-2',
    lg: 'w-7 h-7 border-[2.5px]',
  }

  return (
    <span
      className={cn(
        'inline-block rounded-full border-current border-r-transparent animate-spin',
        tamanos[tamano],
        className
      )}
      role="status"
      aria-label="Cargando"
    />
  )
}
